import { observer } from 'mobx-react'
import styles from './ContactPopup.module.less'
import { Popup } from 'antd-mobile'
import close from '@/assets/images/close.png'
import bg1 from '@/assets/images/contact-bg1.png'
import bg2 from '@/assets/images/contact-bg2.png'
import bg3 from '@/assets/images/contact-bg3.png'
import star from '@/assets/images/star.png'
import finger from '@/assets/images/finger.png'
import { userService } from '@/services/userService/userService'
export interface ContactPopupProps {
  visible: boolean
  title?: string
  description?: string
  onClose?: () => void
}

const ContactPopup = observer((props: ContactPopupProps) => {
  return (
    <Popup
      visible={props.visible}
      onMaskClick={() => props.onClose?.()}
      bodyStyle={{
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
      }}
    >
      <div className={styles.contactPopup}>
        <div className={styles.contactPopupBg}>
          <img className={styles.contactPopupBg1} src={bg1} draggable={false} />
          <img className={styles.contactPopupBg2} src={bg2} draggable={false} />
          <img className={styles.contactPopupBg3} src={bg3} draggable={false} />
        </div>
        <div className={styles.contactPopupTitle}>{props.title || '联系我们'}</div>
        <div className={styles.contactPopupClose} onClick={() => props.onClose?.()}>
          <img src={close} width={16} draggable={false} />
        </div>
        <div className={styles.contactPopupContent}>
          <div className={styles.contactPopupContentTitle}>
            <img className={styles.star} src={star} draggable={false} />
            {props.description || '有任何问题可以随时联系我们'}
          </div>
          <div className={styles.qrCode}>
            <img
              className={styles.qrCodeImg}
              src={userService.getContactQrUrl('mobile')}
              draggable={false}
            />
          </div>
          <div className={styles.contactPopupContentTips}>
            <img className={styles.finger} src={finger} draggable={false} />
            截图保存二维码，微信长按识别添加
          </div>
        </div>
      </div>
    </Popup>
  )
})

export default ContactPopup
